import React, { Component } from 'react';

class Logo extends Component {
    
    render() { 
        return ( 
            <div className="Logo-div">
                <img className="img-logo" src="https://gruppe.com.br/wp-content/uploads/2020/04/gruppe-logotipo-ar.png"/>
            </div>
         );
    }
}

export default Logo;